import { Modal } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React, { FC } from 'react';
import styled from 'styled-components';
import { CredusButton, CredusSelect, CredusText, CredusWrapper } from 'ui';

interface SuspendModalProps {
  setSuspend: React.Dispatch<React.SetStateAction<boolean>>;
  suspend: boolean;
  onSuspendModalOpen: () => void;
}

const SuspendModal: FC<SuspendModalProps> = ({
  onSuspendModalOpen,
  setSuspend,
  suspend,
}) => {
  return (
    <>
      <Modal
        centered
        title={
          <>
            <CredusText size="md" weight="medium">
              Suspend Result
            </CredusText>
          </>
        }
        open={suspend}
        footer={false}
        onOk={() => setSuspend(false)}
        onCancel={() => setSuspend(false)}
        width={500}
      >
        <Container>
          <NotifyWrap>
            <CredusWrapper w="100%">
              <CredusSelect
                variant="medium"
                placeholder="Select reason"
                label="Reason"
                options={[
                  'Exam Malpratice',
                  'Impersonation',
                  'Other (Specify on comment)',
                ]}
              />
            </CredusWrapper>
          </NotifyWrap>
          <NotifyWrap>
            <p>Comments</p>
            <TextAreaWrap></TextAreaWrap>
          </NotifyWrap>
          <CredusWrapper mt="3.2rem" display="flex" justify="flex-end">
            <CredusWrapper
              mb="1rem"
              display="flex"
              gap="1.4rem"
              justify="flex-end"
            >
              <CredusButton onClick={onSuspendModalOpen} variant="secondary">
                Cancel
              </CredusButton>
              <CredusButton onClick={onSuspendModalOpen} variant="primary">
                Confirm
              </CredusButton>
            </CredusWrapper>
          </CredusWrapper>
        </Container>
      </Modal>
    </>
  );
};

export default SuspendModal;

const Container = styled.div`
  padding: 0.8rem;
`;

const NotifyWrap = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
  p {
    margin: 0px;
    margin-bottom: 8px !important;
    font-weight: 500;
    font-size: 14px;
    line-height: 140%;
  }
`;

const TextAreaWrap = styled(TextArea)`
  width: 100%;
  height: 89px !important;

  background: #ffffff;

  border: 1px solid #e0def7;
  border-radius: 8px;
`;
